import { FC } from "react";

import {
  IPassengerDeleteModalPayload,
  PassengerDeleteResultEnum,
  useSystemParams,
} from "@ryde/shared";

import {
  PassengerDeleteBookingChoiceFooter,
  PassengerDeleteKeepBookingFooter,
} from "./parts";

interface IPassengerDeleteFooterProps {
  confirmData: IPassengerDeleteModalPayload;
  onResult: (result: PassengerDeleteResultEnum) => () => void;
}

export const PassengerDeleteFooter: FC<IPassengerDeleteFooterProps> = ({
  confirmData,
  onResult,
}) => {
  const { markBookingAsNewOnPassengerRemoved } = useSystemParams();

  return markBookingAsNewOnPassengerRemoved ? (
    <PassengerDeleteKeepBookingFooter onResult={onResult} />
  ) : (
    <PassengerDeleteBookingChoiceFooter
      confirmData={confirmData}
      onResult={onResult}
    />
  );
};
